import data from '../data'
import React, { useRef, useEffect } from 'react';
import { gsap } from "gsap";

function Projects() {
    let sectionHead = useRef(null);
    let slideHead = useRef(null);

    useEffect(() => {
        gsap.from(slideHead,{duration:5,x:0,opacity:0})
    },[])
    useEffect(() => {
        gsap.from(sectionHead,{duration:5,x:0,opacity:0})
    },[])
    return (
        <section id="projects">
          <h2 id="sectionHead" ref={el => {sectionHead=el}}>Projects & Experience</h2>
          {
              Object.keys(data.experience).map(
                  i => (
                      <React.Fragment>
                        <h3 id="slideHead" ref={el => {slideHead=el}}>{i}</h3>
                        <hr/>
                        <div class="marquee" >
                            <div id="slideShow">
                                {
                                    data.experience[i].map(
                                        j => (
                                            <div class="slideCard">
                                                <img src={j.image} alt="" srcset=""/>
                                                <div class="cardContent">
                                                    <h3 class="cardTitle">{j.head}</h3>
                                                    <p id="cardBody">{j.text}</p>
                                                    <a href={j.url} class="card-button">Learn More</a>
                                                </div>
                                            </div>
                                        )
                                    )
                                }
                            </div>
                        </div>                        
                      </React.Fragment>
                  )
              )
          }
      </section>
    );
}

export default Projects;
  